
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'データ・ソース',
	'dataSourceId': 'ID',
	'dataSourceType': 'タイプ',
	'dataSourceName': '名前',
	'dataSourcePath': 'パス',
	'showInfoForAll': 'すべての視覚化の期間を表示する',
	'hideInfoForAll': 'すべての視覚化の期間を非表示にする',
	'showPerformanceDetails': 'すべてのウィジェットを再実行してパフォーマンス詳細を含める',
	'slotMappingField': 'スロット・マッピング',
	'slotDataMapping': 'マッピング',
	'slotID': 'ID',
	'slotCaption': 'キャプション',
	'slotMandatory': '必須',
	'slotIsMandatory': 'はい',
	'slotIsNotMandatory': 'いいえ',
	'infoNotAvailable': '使用不可',
	'performanceSection': 'パフォーマンス',
	'durationField': '期間',
	'singleQueryTime': 'サーバー・クエリー (ミリ秒)',
	'multipleQueryTime': 'サーバー・クエリー %{name} (ミリ秒)',
	'liveWidgetTotalTime': '合計 (ミリ秒)',
	'renderTimeNotAvailable': '使用不可',
	'renderInProgress': '(進行中)',
	'interactToTriggerQuery': 'ウィジェットと対話してクエリーをトリガーする',
	'fetchQuery': 'クエリーをフェッチする',
	'showSQLMDX': 'SQL/MDX の表示',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'クエリー情報',
	'queryInfoNotAvailable': 'クエリー情報を使用できません',
	'query': 'クエリー',
	'copy': 'コピー',
	'close': '閉じる'
});
